import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const WhyInsurance = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const achievements = [
    { number: '₺2M+', label: 'Müşteri Tasarrufu', icon: 'ri-money-dollar-circle-line' },
    { number: '500+', label: 'Tamamlanan Proje', icon: 'ri-checkbox-circle-line' },
    { number: '%98', label: 'Müşteri Memnuniyeti', icon: 'ri-heart-line' },
    { number: '24/7', label: 'Destek Hizmeti', icon: 'ri-customer-service-2-line' }
  ];

  return (
    <section ref={ref} className="py-24 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, #007dff 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-[1440px] mx-auto px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-block bg-[#007dff]/10 px-6 py-2 rounded-full mb-4">
            <span className="font-poppins text-sm font-semibold text-[#007dff]">
              Yolculuğumuz
            </span>
          </div>
          <h2 className="font-poppins font-bold text-4xl lg:text-5xl text-gray-900 mb-6">
            Neden Sadece Sigorta?
          </h2>
          <p className="font-poppins text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Sektöre odaklanarak derin uzmanlık kazandık. Sigorta dilini konuşuyor, 
            müşteri profilini tanıyor ve en etkili stratejileri uyguluyoruz.
          </p>
        </motion.div>

        {/* Achievements Grid */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid md:grid-cols-4 gap-6 mb-20"
        >
          {achievements.map((achievement, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
              className="bg-gradient-to-br from-[#007dff]/5 to-white rounded-2xl p-6 border border-[#007dff]/20 hover:border-[#007dff]/50 hover:shadow-xl transition-all duration-300 text-center group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#007dff]/10 rounded-xl mx-auto mb-4 group-hover:bg-[#007dff] transition-colors duration-300">
                <i className={`${achievement.icon} text-3xl text-[#007dff] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="font-poppins font-bold text-3xl text-gray-900 mb-2">
                {achievement.number}
              </div>
              <div className="font-poppins text-sm text-gray-600">
                {achievement.label}
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="mt-20 text-center"
        >
          <div className="bg-gradient-to-br from-[#007dff] to-[#0052bb] rounded-3xl p-12 relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute inset-0" style={{
                backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
                backgroundSize: '30px 30px'
              }}></div>
            </div>
            <div className="relative z-10">
              <h3 className="font-poppins font-bold text-3xl text-white mb-4">
                Siz de Başarı Hikayemizin Parçası Olun
              </h3>
              <p className="font-poppins text-white/90 text-lg mb-8 max-w-2xl mx-auto">
                120+ sigorta acentesi bize güveniyor. Dijital büyüme yolculuğunuza bugün başlayın.
              </p>
              <a
                href="/iletisim"
                className="inline-flex items-center gap-2 bg-white text-[#007dff] px-8 py-4 rounded-full font-poppins font-semibold text-[15px] hover:bg-white/90 transition-all duration-300 shadow-xl whitespace-nowrap"
              >
                Hemen Başlayın
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyInsurance;
